import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { HttpErrorHandler } from 'app/shared/http-error-handler';
import { List } from 'app/shared/list';

import { Notification, NotificationFilter } from 'app/_models/notification';
import { NotificationService } from 'app/_services/notification.service';

@Component({
  selector: 'app-ships',
  templateUrl: './notification-list.component.html',
})
export class NotificationListComponent extends List implements OnInit {
  errorMessage: string;
  filter: NotificationFilter = new NotificationFilter();
  // Mixins prototypes
  errorRouter: Router;

  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(notificationService, new Notification(), router, route);
  }

  ngOnInit() {
    this.initList('notifications', this.filter);
  }
  listCallback() {
    this.collection = this.collection.filter(this.filterBySend);
  }

  filterBySend(obj) {
    if ('status' in obj && obj.status === 'send') {
      return true;
    } else {
      return false;
    }
  }

  createNotification() {
    this.notificationService.create().subscribe((notification) => {
      this.router.navigate([`/notifications/${notification.id}`]);
    });
  }

  deleteNotification(notification: Notification) {
    this.notificationService.delete(notification.id).subscribe(
      (empty) => this.list(this.currentPage),
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/notifications/notification-list/notification-list.component.ts